import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchAllAuthors } from 'auth/store/users/actions';
import { fetchMyUser } from 'auth/store/auth/actions';
import OnlineAppSync from 'offline/containers/OnlineAppSync';
import AppHeader from 'base/containers/AppHeader';
import Flex from '../../components/Flex/index';
import AppRoutes from '../../../AppRoutes';
import AppSidebar from '../AppSidebar/index';

class AppMain extends React.PureComponent {
  componentDidMount() {
    this.props.fetchMyUser();
    this.props.fetchAllAuthors();
  }

  render() {
    return (
      <>
        <AppHeader />
        <Flex className="app__main" style={{ zIndex: 0 }}>
          <OnlineAppSync />
          <AppSidebar className="print-hide" />
          <Flex flexDirection="column">
            <AppRoutes />
          </Flex>
        </Flex>
      </>
    );
  }
}
AppMain.propTypes = {
  fetchMyUser: PropTypes.func.isRequired,
  fetchAllAuthors: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  fetchMyUser,
  fetchAllAuthors,
};

export default connect(null, mapDispatchToProps)(AppMain);
